import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { OwnershipTransferCustomerStep } from '../Constant/Constant';
import { setCurrentStep, setTransferCellcomDu } from '../OwnershipTransferCustomerSlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const CellcomDu = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.AnotherServicePage,
        messageText: DWHMessageText.AnotherServicePageDisplayed,
        status: DWHStatus.Ongoing
      });
    }
  }, []);
  function setCellcomDu(flag) {
    if (flag) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.AnotherServicePage,
        messageText: DWHMessageText.AnotherServicePageYesButtonClicked,
        status: DWHStatus.Ongoing
      });
    }
    else {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.AnotherServicePage,
        messageText: DWHMessageText.AnotherServicePageNoButtonClicked,
        status: DWHStatus.Ongoing
      });
    }
    props.setTransferCellcomDu(flag);
    props.setCurrentStep(OwnershipTransferCustomerStep.SubscriberPersonalData);
  }
  return (
    <div className='stepContainer'>
      <div className='cellcomDu'>
        <Image src={require('../Icons/cellcomDu.svg')} />
        <div className='l-title'>זיהינו שיש למנוי שלך שירות קו נוסף</div>
        <div className='m-title'>האם להעביר גם אותו לבעלותך?</div>
        <div className='continue-button'>
          <BtnSubmit text={'כן, העבירו את השירות לבעלותי'} onclick={() => setCellcomDu(true)} />
          <div>
            <a className='general-message-link' onClick={() => setCellcomDu(false)}>
              אין צורך, תודה
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setTransferCellcomDu,
  setCurrentStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(CellcomDu);
